module.exports = __webpack_public_path__ + "static/media/loader.b54a16d0.gif";